angular.module('aprima-provider-api').factory('MessageLocker',
    ['Locker',
        function (Locker) {
            'use strict';

            function MessageLocker(message, $scope, lockType, messageId) {
                Locker.call(this, message, $scope, lockType || 'Message', messageId, 'Message');
            }

            MessageLocker.prototype = Object.create(Locker.prototype, {});
            MessageLocker.prototype.constructor = MessageLocker;

            return MessageLocker;
        }]);